import {FC} from "react";
import "./ClientHierarchyDetailsColumn.scss";
import {useClientEntity} from "../../context";
import {DetailsColumnHeader} from "../../overview";
import {TabColumn} from "../../../tab-content";
import {useTranslation} from "react-i18next";
import {ClientHierarchyBusinessInformation} from "./ClientHierarchyBusinessInformation";
import {
  ClientAddress,
  clientAddressIsPrimary,
  Oem,
  toTelecomNumbers
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {ClientHierarchyStatusBar} from "./ClientHierarchyStatusBar";
import {LinkedOperationalEntities} from "./LinkedOperationalEntities";
import {ClientAddress as ClientAddressComponent} from "./ClientAddress";
import {ClientOems} from "./ClientOems";
import {ClientTelecomNumbers} from "./ClientTelecomNumbers";

export const ClientHierarchyDetailsColumn: FC = () => {
  const {
    entity: {
      caId,
      custLegalName,
      clientNameplates,
      custStatus,
      addresses,
      custPhoneNumber,
      custParentId,
      mappedOperationalEntities
    }
  } = useClientEntity();

  const {t} = useTranslation();
  // Find the first address marked as Primary:

  let oems: Oem[] = [];
  const linkedOperationalEntities = mappedOperationalEntities
    ? mappedOperationalEntities
    : [];
  let addressToDisplay: ClientAddress | undefined = undefined;

  // Pick the first address flagged as primary, or if there are none flagged as such, just pick the first address from the list.
  if (addresses?.length) {
    addressToDisplay = addresses.find(clientAddressIsPrimary) || addresses[0];
  }

  if (clientNameplates) {
    oems = clientNameplates.map(nameplate => ({
      id: nameplate.oemId,
      abbreviation: nameplate.oemAbbreviation,
      locationId: nameplate.oemLocationId,
      nameplateDescription: nameplate.nameplateDesc
    }));
  }

  return (
    <TabColumn
      name={"details-column"}
      header={
        <DetailsColumnHeader
          label={t("client-entity-details.details-card-label")}
          id={caId}
        />
      }>
      <ClientHierarchyStatusBar id={caId} status={custStatus} />
      <ClientHierarchyBusinessInformation
        caId={caId}
        custLegalName={custLegalName}
        custParentId={custParentId}
      />
      <ClientAddressComponent
        id={caId}
        streetAddressLine1={addressToDisplay?.addrLine1}
        streetAddressLine2={addressToDisplay?.addrLine2}
        city={addressToDisplay?.city}
        state={addressToDisplay?.provinceCd}
        country={addressToDisplay?.countryCd}
        zip={addressToDisplay?.postalCd}
      />
      <ClientTelecomNumbers
        custPhoneNumber={toTelecomNumbers(custPhoneNumber)}
        id={caId}
      />
      <LinkedOperationalEntities linkedEntities={linkedOperationalEntities} />
      <ClientOems id={caId} oems={oems} />
    </TabColumn>
  );
};
